export default __webpack_public_path__ + "static/media/AGRONEGOCIOS.6c2debb6.png";